export default class ComponentAbstract {
  constructor(el, options, type) {
    this.el      = el
    this.$el     = $(el)
    this.type    = type || 'module'
    this.options = options || 'module'

    this.options = $.extend(
      true,
      this.options,
      options,
      this.$el.data(type + '-options')
    )

    this.mainClassName = this._getClassName()
  }

  find(element, modifier, where) {

    if (!this.mainClassName) {
      console.error('cannot find main class name for ' + this.el)
    }

    modifier = modifier || false
    where = where || this.mainClassName
    var selector = '.' + where + '__' + element
    if (modifier)
      selector += '.-' + modifier

    return this.$el.find(selector)
  }

  setCookie(cname,cvalue,exdays) { 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  _getClassName() {
    var prefix = this.type === 'module' ? 'm-' : 'c-';
    var className = this.el.className.split(' ').filter(function(cn) {
      // //console.log(prefix, cn.indexOf(prefix))
        return cn.indexOf(prefix) === 0;
    });

    if (className.length) {
      return className[0]
    } else {
      // console.error('cannot find main class name for ' + this.type)
      return false
    }
  }
}



/** WEBPACK FOOTER **
 ** ./system/abstract.js
 **/